import { render, staticRenderFns } from "./PcBigIconButton.vue?vue&type=template&id=2661af27"
import script from "./PcBigIconButton.vue?vue&type=script&lang=js"
export * from "./PcBigIconButton.vue?vue&type=script&lang=js"
import style0 from "./PcBigIconButton.vue?vue&type=style&index=0&id=2661af27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
